module.exports = __webpack_public_path__ + "img/1_26@3x.c5aa11b3.png";